import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import Loader from '../../util/Loader'
import { actions } from '../../redux/modules/leadFunctions/leadNoteActions'

import Notes from './components/notes/Notes.component'

const propTypes = {}

class LeadNotes extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: 0,
      contentData: null
    }
  }

  componentWillMount() {
    this.props.leadNotesRefresh({
      leadId: this.props.leadId
    })
  }

  // notes things
  handleToggleNoteEditArea = () => {
    if (this.state.currentNote) {
      this.setState({
        currentNote: null,
        currentNoteId: null,
        noteAddEditContainer: true
      })
    } else {
      this.setState({
        noteAddEditContainer: !this.state.noteAddEditContainer
      })
    }
  }

  createNote = params => {
    this.props.createNote({
      content: params,
      userId: this.props.authentication.userId,
      leadId: this.props.leadId
    })

    this.handleToggleNoteEditArea()
  }

  updateNote = params => {
    this.props.updateNote({
      leadId: this.props.leadId,
      noteId: this.state.currentNoteId,
      content: params
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null
    })
  }

  deleteNote = () => {
    this.props.deleteNote({
      noteId: this.state.currentNoteId,
      leadId: this.props.leadId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null,
      noteAddEditContainer: false
    })
  }

  handleRowNoteClick = row => {
    this.setState({
      noteAddEditContainer: true,
      currentNote: row,
      currentNoteId: row.id
    })
  }

  render() {
    if (!this.props.leadNoteActions.leadNotes) {
      return <Loader />
    }
    return (
      <div>
        <Notes
          // notes props
          currentNote={this.state.currentNote}
          currentNoteId={this.state.currentNoteId}
          notes={this.props.leadNoteActions.leadNotes && this.props.leadNoteActions.leadNotes.data}
          handleToggleNoteEditArea={this.handleToggleNoteEditArea}
          noteAddEditContainer={this.state.noteAddEditContainer}
          createNote={this.createNote}
          handleRowNoteClick={this.handleRowNoteClick}
          updateNote={this.updateNote}
          userId={this.props.authentication.user.userId}
          deleteNote={this.deleteNote}
        />
      </div>
    )
  }
}

const mapStateToProps = ({ leadNoteActions, authentication }, ownProps) => ({
  leadNoteActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(actions, dispatch)
})

LeadNotes.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LeadNotes))



// WEBPACK FOOTER //
// ./src/pages/lead/LeadNotes.container.js